import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment/moment';
moment.locale('ja');

/**
 * Generated class for the DateFormatPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'dateFormat',
})
export class DateFormatPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    return moment(value).format(args[0]);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date/date-format.ts